import React, { Component } from 'react';
import { connect } from 'react-redux';
import Switch from '../../../components/UI/Switch/Switch';
import classes from './DeviceGroupSchedulePause.css';
import Box from '../../../hoc/Box/Box';
import GroupPauseScheduleForm from '../GroupPauseScheduleForm/GroupPauseScheduleForm';
import Modal from '../../../components/UI/Modal/Modal';
import Confirm from '../../../components/UI/Confirm/Confirm';
import * as actions from '../../../store/actions/index';

class SchedulePause extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showCreatePauseScheduleForm: false,
      template: this.props.customTemp,
      customTemp: this.props.customTemp,
      canEdit: this.props.customTemp,
      confirmModal: false,
      action: null,
      result: null,
      isScheduleEnabled: this.props.customTemp
        ? this.props.customTemp.enable
        : false
    };

    this.checkSteeringDevicesInGroup = this.checkSteeringDevicesInGroup.bind(this);

  }

  modalCancelHandlerForCreatePauseScheduleForm = () => {
    this.props.modalCancel('close');
    this.setState({ showCreatePauseScheduleForm: false });
  };

  closeModal = (type) => {
    this.setState({ showCreatePauseScheduleForm: false });
    this.props.modalCancel(type === 'closeModal' ? '' : 'close');
  };

  confirmModalCancelHandler = () => {
    this.props.onCancel();
  };

  isCustomTemplateEnabled() {
    let customTemplate = this.props.customTemp;
    return customTemplate.enable;
  }

  getSelectedDays(daysOfWeek) {
    let days = {
      1: 'Mo',
      2: 'Tu',
      3: 'We',
      4: 'Th',
      5: 'Fr',
      6: 'Sa',
      7: 'Su',
    };
    daysOfWeek.sort();
    return daysOfWeek.map((d) => days[d]).join(', ');
  }

  convertTo12Hour(hour) {
    let hrs = hour.split(':');
    let hr = parseInt(hrs[0], 10);
    let m = hrs[1];

    let remainder = hr % 12;
    let h = remainder === 0 ? 12 : remainder;

    let ampm = hr < 12 ? 'AM' : 'PM';
    let value = h + ':' + m + ' ' + ampm;
    return value;
  }

  onOpenModal = (result, action) => {
    this.setState({
      confirmModal: true,
      result,
      action,
    });
  };

  handleTogglePause = () => {
    let customTemplate = this.props.customTemp;
    if (customTemplate) {
      let schedule =
        customTemplate.customSchedules && customTemplate.customSchedules.length
          ? customTemplate.customSchedules
          : undefined;

      // if (!this.props.handleGroupSteering(this.props.groupDetails.devices, 'EDIT_SCHEDULE', { 'customSchedules': schedule, 'enable': !this.state.isScheduleEnabled }, this.props.groupSteeringDevices)) {

        if (!this.state.isScheduleEnabled) {
          const template = (
            <div>
              <h2 style={{ textAlign: 'center' }}>Enable A Pause Schedule</h2>
              <p style={{ textAlign: 'center', fontWeight: 'normal' }}>
                This will pause all internet connectivity to this device(s)
                according to it's schedule.
              </p>
              <p style={{ textAlign: 'center', fontWeight: 'normal' }}>
                Are you sure you want to Proceed?
              </p>
            </div>
          );
          this.onOpenModal(template);
        } else {
          const template = (
            <div>
              <h2 style={{ textAlign: 'center' }}>Disable A Pause Schedule</h2>
              <p style={{ textAlign: 'center', fontWeight: 'normal' }}>
                This will unpause all internet connectivity to this device(s)
                according to it's schedule.
              </p>
              <p style={{ textAlign: 'center', fontWeight: 'normal' }}>
                Are you sure you want to Proceed?
              </p>
            </div>
          );
          this.onOpenModal(template);
        }

        this.setState((state) => ({ isScheduleEnabled: !state.isScheduleEnabled }));
      // }
    }
  };

  confirmModalConfirmHandler = () => {
    let customTemplate = this.props.customTemp;
    if (customTemplate) {
      let schedule =
        customTemplate.customSchedules && customTemplate.customSchedules.length
          ? customTemplate.customSchedules
          : null;
      let payload = {
        template: {
          GroupPauseScheduleForm: true,
          name: customTemplate && customTemplate.name,
          shouldPause: null,
          schedulePause: this.state.isScheduleEnabled,
          schedules: schedule,
        },
        deviceGroupId: this.props.groupDetails.id,
        isScheduleEnabled: this.state.isScheduleEnabled,
        templateId: 'custom',
        action: 'put',
      };

      this.props.createGroupPauseSchedule(payload);

      // setTimeout(() => {
      //   this.props.pauseDeviceGroup(payload);
      // }, 1000);
    }

    this.confirmModalCancelHandler('close');
  };

  confirmModalCancelHandler = (e) => {
    this.setState({
      confirmModal: false,
      action: null,
      result: null,
      isScheduleEnabled: this.props.customTemp
        ? this.props.customTemp.enable
        : false,
    });
    if (e === 'close') {
      //this.props.closeGroupDetailsPage();
    }
  };

  checkSteeringDevicesInGroup() {
    
      this.setState({ showCreatePauseScheduleForm: true })
    
  }

  render() {
    if (this.props.freeze === undefined) {
      return <Box> &nbsp; </Box>;
    }
    let customTemplate = this.props.customTemp;
    let selectedDays = '';
    let scheduleName = '';
    let startTime = '';
    let endTime = '';
    let selectedTime = '';

    if (this.state.canEdit) {
      let schedule =
        customTemplate &&
          customTemplate.customSchedules &&
          customTemplate.customSchedules.length
          ? customTemplate.customSchedules
          : undefined;
      selectedDays =
        schedule[0] && schedule[0].daysOfWeek
          ? this.getSelectedDays(schedule[0].daysOfWeek)
          : '';
      startTime =
        schedule[0] && schedule[0].startTime
          ? this.convertTo12Hour(schedule[0].startTime)
          : '';
      if (schedule[1] && schedule[1].endTime) {
        endTime = this.convertTo12Hour(schedule[1].endTime);
      } else {
        if (schedule[0] && schedule[0].endTime === null) {
          endTime = this.convertTo12Hour('00:00');
        } else {
          endTime =
            schedule[0] && schedule[0].endTime
              ? this.convertTo12Hour(schedule[0].endTime)
              : '';
        }
      }

      selectedTime = startTime + '-' + endTime;
      scheduleName = customTemplate && customTemplate.name;
    }
    let disableLink = {};
    if(this.props.groupSteeringDevices.length){
      disableLink = { opacity: '0.6', pointerEvents: 'none', cursor: 'not-allowed'}
    }

    return (
      <Box>
        <div className={classes.SchedulePause}>
          <h3 id="SchedulePauseText" style={{ margin: '1rem' }}>
            Scheduled Pause
          </h3>
          {!this.state.canEdit ? (
            <button
              id="createScheduleButton"
              className={classes.CreateScheduleButton}
              onClick={this.checkSteeringDevicesInGroup}
            >
              Create Group Pause Schedule
            </button>
          ) : (
            <div className={classes.EditPauseSchedule}>
              <div className={classes.editNameDetails}>
                <div id="scheduleName" className={classes.BodyTitle}>
                  <span className={classes.scheduleName}>{scheduleName}</span>
                </div>
                <div className={classes.spacer} />
                <Switch
                  id="GrpSchedulePauseToggle"
                  aria-checked={this.state.isScheduleEnabled}
                  aria-label="enable schedule"
                  onText="ENABLED"
                  offText="DISABLED"
                  onChange={this.handleTogglePause}
                  checked={this.state.isScheduleEnabled}
                />
                <div className={classes.spacer} />
              </div>

              <div id="GroupSchedulePause" className={classes.editDatesDetails}>
                <span className={classes.GroupEditSchedulePauseDetails}>
                  {selectedDays}
                </span>
                <span className={classes.GroupEditSchedulePauseDetails}>
                  {selectedTime}
                </span>
                 <div className={classes.EditScheduleButton}
                // title={this.props.groupSteeringDevices.length ? 'Group device is in steering and pause cannot be edited' : ''}
                 >
                  <a
                    // style={disableLink}
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ showCreatePauseScheduleForm: true });
                    }}
                   >
                    Edit Group Schedule
                  </a>
                </div> 
              </div>
            </div>
          )}
        </div>

        {this.state.showCreatePauseScheduleForm && (
          <Modal
            show={this.state.showCreatePauseScheduleForm}
            modalClosed={this.modalCancelHandlerForCreatePauseScheduleForm}
          >
            <GroupPauseScheduleForm
              closeModal={this.closeModal}
              onCancel={this.modalCancelHandlerForCreatePauseScheduleForm}
              groupId={this.props.groupDetails.id}
              template={Object.assign({}, this.props.customTemp)}
              customEnabled={
                this.props.customTemp ? this.props.customTemp.enable : false
              }
              handleGroupSteering={this.props.handleGroupSteering}
              groupDevices={this.props.groupDetails.devices}
              isDeviceSuspend={this.props.isDeviceSuspend}
            />
          </Modal>
        )}
        {this.state.confirmModal && (
          <Modal
            deviceGroupConfirmation="true"
            show={this.state.confirmModal}
            modalClosed={this.confirmModalCancelHandler}
          >
            <Confirm
              id={'GroupSchedulePauseConfirm'}
              deviceGroupConfirmation={true}
              action={this.state.action}
              result={this.state.result}
              confirm={this.confirmModalConfirmHandler}
              cancel={this.confirmModalCancelHandler}
              confirmButtonLabel="Yes"
              camcelButtonLabel="Cancel"
            />
          </Modal>
        )}
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    deviceGroups: state.deviceGroups.deviceGroups,
    groupLoading: state.deviceGroups.loading,
    groupLoaded: state.deviceGroups.loaded,
    groupSuccess: state.deviceGroups.success,
    groupError: state.deviceGroups.error,
  };
};

const mapDispatchToProps = (dispatch) => (
  {
    createGroupPauseSchedule: payload => dispatch(actions.createGroupPauseSchedule(payload))
  }
)

export default connect(mapStateToProps, mapDispatchToProps)(SchedulePause);
